interface CheckoutModalProps {
  title?: string;
  message?: string;
  loader?: boolean;
  url?: string;
  urlText?: string;
  success?: boolean;
}

const CheckoutModal = ({
  title = '',
  message = '',
  loader = false,
  url = '',
  urlText = '',
  success = true,
}: CheckoutModalProps) => (
  <div className="checkout-modal">
    <div className="modal-content">
      <h1>{title}</h1>
      <p>{message}</p>

      {success && <i className="icon-ok-sign" />}

      {url && urlText && (
        <p>
          <a href={url}>{urlText}</a>
        </p>
      )}

      {loader && <div className="loader">Loading...</div>}
    </div>
  </div>
);

export default CheckoutModal;
